import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { type ApplicationStage, ApplicationKind } from '../../../api/types';
import { useMultipleDealerIds } from '../../../components/contexts/DealerContextManager';
import ApplicationList from '../../shared/ApplicationList';
import { getApplicationColumns } from '../../shared/ApplicationList/helpers';

export type ApplicationTabListProps = {
    configuratorId: string;
    stage: ApplicationStage;
    setSelectedApplications: React.Dispatch<React.SetStateAction<string[]>>;
};
const ApplicationTabList = ({ configuratorId, stage, setSelectedApplications }: ApplicationTabListProps) => {
    const { dealerIds } = useMultipleDealerIds();
    const showColumns = useMemo(() => getApplicationColumns(stage, { hasModule: false }), [stage]);

    const navigate = useNavigate();
    const onRow = useCallback(
        id => {
            navigate(`l/${id}`);
        },
        [navigate]
    );

    if (!stage) {
        return null;
    }

    return (
        <ApplicationList
            configuratorId={configuratorId}
            dealerIds={dealerIds}
            kind={ApplicationKind.Configurator}
            onRow={onRow}
            setSelectedApplication={setSelectedApplications}
            showColumns={showColumns}
            stage={stage}
        />
    );
};

export default ApplicationTabList;
